import React, { useCallback } from 'react'
import styled from 'styled-components'
import { rem } from 'polished'

import { ReviewListSortOption, SORT_OPTION_MOST_RELEVANT } from 'constants/review'
import RadioButtonInput from 'components/Luxkit/RadioButton/RadioButtonInput'
import Dropdown from 'components/Luxkit/Dropdown'
import Modal from 'components/Luxkit/Modal/Modal'
import AssistChip from 'components/Luxkit/Chips/AssistChip'
import { mediaQueryUp } from 'components/utils/breakpoint'
import Breakpoint from 'components/Common/Breakpoint'
import useToggle from 'hooks/useToggle'
import Group from 'components/utils/Group'

const SortMenuDesktop = styled(Dropdown)`
  display: none;
  min-width: ${rem(220)};
  padding: ${rem(16)};
  background-color: ${props => props.theme.palette.neutral.eight};
  box-shadow: ${props => props.theme.shadow.bottom.small};

  ${mediaQueryUp.tablet} {
    display: block;
  }
`

const OptionsWrapper = styled.div`
  position: relative;
`
interface Props {
  sortValue: string;
  sortOptions: Array<ReviewListSortOption>;
  onSelect: (option: string) => void;
}

function UserReviewSort(props: Props) {
  const { sortValue, sortOptions, onSelect } = props

  const [isOpenSort, , openSort, onClose] = useToggle()

  const currentOption = sortOptions.find(option => option.value === sortValue) ?? SORT_OPTION_MOST_RELEVANT

  const onChange = useCallback<React.ChangeEventHandler<HTMLInputElement>>((e) => {
    const value = e.currentTarget.value
    const selected = sortOptions.find(option => option.value === value)

    onClose()
    onSelect(selected.value)
  }, [onClose, onSelect, sortOptions])

  const sortInputs = <Group direction="vertical" gap={16}>
    {sortOptions.map(option => <RadioButtonInput
      key={option.value}
      checked={currentOption.value === option.value}
      onChange={onChange}
      name={option.label}
      value={option.value}
      data-testid={`sort-option-${option.value}`}
    >
      {option.label}
    </RadioButtonInput>)}
  </Group>

  return (
    <OptionsWrapper>
      <AssistChip size="medium" variant="filled" onClick={openSort}>
        Sort by: {currentOption.label}
      </AssistChip>
      <SortMenuDesktop data-testid="sort-options-dropdown" open={isOpenSort} onClose={onClose} position="below" alignment="left">
        {sortInputs}
      </SortMenuDesktop>
      <Breakpoint max="mobile">
        <Modal title="Sort by" onClose={onClose} isOpen={isOpenSort}>
          {sortInputs}
        </Modal>
      </Breakpoint>
    </OptionsWrapper>
  )
}

export default UserReviewSort
